import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, GridArrowDownwardIcon, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { ProductService } from "../../service/product.service";


function CurrentStockList() {

    const productService = new ProductService();

    const [brandsData, setbrandsData] = useState<any[]>([]);

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();

    const toBrandDetails = (bIndex: string, action: string) => {


        navigate('../branddetails', {
            state: {
                brandDetails: brandsData[Number(bIndex) - 1],
                brandsData: brandsData,
                action: action
            }
        })
    };

    const [open, setOpen] = React.useState(false);



    const columns: GridColDef[] = [
        { field: 'id', headerName: 'S.No', flex: 1, width: 200 },



        { field: 'ProductCode', headerName: 'Product Code', flex: 1 },
        { field: 'Model', headerName: 'Model No', flex: 1 },
        { field: 'GroupModel', headerName: 'Group Model No', flex: 1 },
        { field: 'ProductName', headerName: 'Product Name', flex: 1 },
        { field: 'Stock', headerName: 'Stock', flex: 1 }


    ];
    //useEffect(() => {
    const submitRequest = (checkApprovalStatus: number) => {

    }//, [selectedEnterprise, selectedStatus]);

    const loadbrandsData = () => {

        productService.getCurrentStock().then(data => {
            const res = data.data;
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;
                return {
                    ...person,
                    id: cnt1,
                    action: cnt1 //person.brandId,
                };

            });
            setbrandsData(peopleWithImages)


        });

    }


    const downloadCSV = () => {



    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            loadbrandsData();
        }

    }, [])

    function CustomToolbar() {
        return (
            <GridToolbarContainer    >
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    return (
        <div className="App border card">
            <div className="col-md-12  row">
                <div className="col-10 text-right font_size_12px"></div>

                
            </div>
            {
                <div style={{ width: '100%' }}>
                    <DataGrid
                        slots={{
                            toolbar: CustomToolbar,
                        }}
                        // table customization start
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: "#D0D0D0"
                            },
                            '& .Mui-odd': {
                                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                            },

                            '& .Mui-even': {
                                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                            },

                            '& .Mui-cellown': {
                                paddingTop: 0, paddingBottom: 0

                            },

                        }}

                        getCellClassName={(params) => 'Mui-cellown'}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                        autoHeight={true}
                        getRowHeight={() => 30}

                        // table customization


                        rows={brandsData}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 25 },
                            },
                        }}
                        pageSizeOptions={[25, 50, 100]}

                    />
                </div>
            }
        </div>

    );
}


export default CurrentStockList;
